const resolveData = (item: PriceTypes.PriceListWithLadderLogisticItem | PriceTypes.priceList) => {
  return {
    semiManaged: 'true',
    currentQuantity: `${item.minQuantity}`,
    totalPrice: item.formatTotalPrice,
    shippingPrice: item.formatShippingPrice,
    productPrice: item.formatProductPrice,
    ...(item.type && { carrierCode: item.type }),
    ...(item.requestId && { requestId: item.requestId }),
    ...(item.formatOriginalProductPrice && {
      productPrice: item.formatOriginalProductPrice,
      promotionProductPrice: item.formatProductPrice,
    }),
    ...(item.formatOriginalShippingPrice && {
      shippingPrice: item.formatOriginalShippingPrice,
      promotionShippingPrice: item.formatShippingPrice,
    }),
    ...(item.formatOriginalTotalPrice && {
      totalPrice: item.formatOriginalTotalPrice,
      promotionTotalPrice: item.formatTotalPrice,
    }),
  };
};

export default (
  key: string,
  priceList:
    | PriceTypes.priceList[]
    | PriceTypes.PriceListWithLadderLogisticItem[]
    | PriceTypes.PriceListWithLadderLogisticItem
    | PriceTypes.priceList
    | null,
  type = 'EXP',
  ext = '',
) => {
  try {
    if (!priceList) return null;
    const params = Array.isArray(priceList)
      ? priceList.map((item) => resolveData(item))
      : resolveData(priceList);
    const q = window.goldlog_queue || (window.goldlog_queue = []);
    q.push({
      action: 'goldlog.record',
      arguments: [key, type, `params=${JSON.stringify(params)}${ext ? '&' + ext : ''}`, 'POST'],
    });
  } catch (error) {
    console.warn(error);
  }
};
